/* OMINA 3.0 — Défilement doux à la molette et au trackpad.

   POURQUOI LA BARRE LATÉRALE BUGGAIT
   La version 2.0 interpolait la position de défilement dans une boucle rAF.
   Quand l'utilisateur attrapait la barre de défilement, le navigateur écrivait
   une position pendant que la boucle en écrivait une autre : les deux se
   disputaient le scroll, d'où les sauts. Trois garde-fous corrigent cela :

     1. tout appui de pointeur interrompt immédiatement l'interpolation —
        un geste utilisateur gagne toujours ;
     2. un appui dans la zone de la barre de défilement (au-delà de la largeur
        du document) désactive complètement l'interception jusqu'au relâchement ;
     3. l'arrêt annule la frame en attente et relâche le verrou, sinon une frame
        déjà en file réécrivait la position après coup.

   Le lissage ne s'applique qu'à la molette et au trackpad sur pointeur fin.
   Le tactile, le clavier, les ancres et la barre restent 100 % natifs. */
(function () {
  'use strict';

  if (window.ominaSmoothScroll) return; // garde anti double initialisation

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var coarsePointer = window.matchMedia('(pointer: coarse)');

  var EASE = 0.14;
  var LINE_HEIGHT = 16;

  var target = window.scrollY;
  var animating = false;
  var frame = null;
  var scrollbarDrag = false;

  function inDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function enabled() {
    if (reduceMotion.matches) return false;
    if (coarsePointer.matches) return false;
    if (inDesignMode()) return false;
    if (scrollbarDrag) return false;
    return true;
  }

  function maxScroll() {
    return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  }

  /* Une zone défilante interne (tiroir panier, modale, textarea) garde le
     défilement natif : on ne préempte pas son événement. */
  function hasScrollableAncestor(node) {
    while (node && node !== document.body && node !== document.documentElement) {
      if (node.nodeType === 1) {
        var overflowY = window.getComputedStyle(node).overflowY;
        if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight + 1) {
          return true;
        }
      }
      node = node.parentNode;
    }
    return false;
  }

  function stop() {
    if (frame !== null) {
      cancelAnimationFrame(frame);
      frame = null;
    }
    animating = false;
    target = window.scrollY;
  }

  function step() {
    frame = null;

    if (!enabled()) {          // l'état a pu changer depuis la demande de frame
      animating = false;
      return;
    }

    var current = window.scrollY;
    var distance = target - current;

    if (Math.abs(distance) < 0.5) {
      window.scrollTo({ top: target, behavior: 'instant' });
      animating = false;
      return;
    }

    window.scrollTo({ top: current + distance * EASE, behavior: 'instant' });
    frame = requestAnimationFrame(step);
  }

  function onWheel(event) {
    if (!enabled()) return;
    if (event.ctrlKey || event.metaKey) return;   // zoom navigateur
    if (event.defaultPrevented) return;
    if (hasScrollableAncestor(event.target)) return;

    var delta = event.deltaY;
    if (event.deltaMode === 1) delta *= LINE_HEIGHT;
    else if (event.deltaMode === 2) delta *= window.innerHeight;
    if (!delta) return;

    event.preventDefault();

    if (!animating) target = window.scrollY;
    target = Math.max(0, Math.min(target + delta, maxScroll()));

    if (!animating) {
      animating = true;
      frame = requestAnimationFrame(step);
    }
  }

  /* Garde-fou 1 et 2 : le pointeur reprend toujours la main. Un appui au-delà
     de la largeur du document vise la barre de défilement : on se retire
     complètement jusqu'au relâchement. */
  function onPointerDown(event) {
    stop();
    if (event.clientX > document.documentElement.clientWidth) {
      scrollbarDrag = true;
    }
  }

  function onPointerUp() {
    scrollbarDrag = false;
    target = window.scrollY;
  }

  /* Toute autre source de défilement devient la nouvelle référence. */
  function onScroll() {
    if (!animating) target = window.scrollY;
  }

  window.addEventListener('wheel', onWheel, { passive: false });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', stop, { passive: true });
  window.addEventListener('pointerdown', onPointerDown, { passive: true });
  window.addEventListener('pointerup', onPointerUp, { passive: true });
  window.addEventListener('pointercancel', onPointerUp, { passive: true });
  window.addEventListener('touchstart', stop, { passive: true });
  reduceMotion.addEventListener('change', stop);
  coarsePointer.addEventListener('change', stop);

  window.ominaSmoothScroll = { stop: stop, isEnabled: enabled };
})();
